import { render } from "./ScoreDistribution.vue?vue&type=template&id=e032d3be"
import script from "./ScoreDistribution.vue?vue&type=script&lang=js"
export * from "./ScoreDistribution.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__